import React from "react";
import "./Footer.css";
import { useTranslation } from "react-i18next";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();

  const socialLinks = {
    facebook: "https://www.facebook.com/people/lellahom-%D9%84%D9%84%D8%A7%D9%87%D9%85/61558160653228/#",
    instagram: "https://www.instagram.com/lellahom4/",
    tiktok: "https://www.tiktok.com/@lellahom4?_t=ZM-8xN7hpCsCs4&_r=1"
  };

  return (
    <>
      <footer className="footer">
        <div className="footer__container">
          {/* Contact Information */}
          <div className="footer_contact">
            <h3 className="footer_title">{t('footer.contact_us')}</h3>
            <div className="footer_address">
              <div className="contact_item">
                <strong>{t('links.email')}:</strong>
                <span>contact@lellahom.com</span>
              </div>
              <div className="contact_item">
                <strong>{t('links.phone')}:</strong>
                <span>+216 56 295 111</span>
              </div>
            </div>
          </div>

          {/* Social Media Icons */}
          <div className="footer_social">
            <h3 className="footer_title">{t('footer.follow_us')}</h3>
            <div className="social_links">
              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our Facebook page"
              >
                <FaFacebookF color="black" />
              </a>

              <a
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our Instagram profile"
              >
                <FaInstagram color="black" />
              </a>

              <a
                href={socialLinks.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our TikTok profile"
              >
                <svg
                  className="tiktok-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="black"
                >
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="footer_bottom">
          <div className="footer_bottom_links">
            <Link to="/terms">
              {t('cart.privacy_policy')}
            </Link>
          </div>
          <p>
            © 2020–{new Date().getFullYear()} Lellehom Store. All Rights Reserved.
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
